
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetochennaicabbooking() {



    const cardData =
    {
        keyword: 'Pune to Chennai Cab Booking ',
        heading: 'Platinum24 Cabs: Pune to Chennai Cab Booking',
        headingDescription: ' Platinum24 Cabs provides trusted Pune to Chennai cab booking services, ideal for business professionals, families, and long-distance travelers. Whether you’re heading to Chennai for IT work, visiting Marina Beach and Kapaleeshwarar Temple, or traveling for family functions, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and secure ride. With punctual pickups, skilled chauffeurs, and transparent pricing, we make your intercity journey hassle-free. From one-way bookings to customized return packages, Platinum24 Cabs guarantees a smooth and reliable Pune to Chennai travel experience.',

        top: 'Top Places to Visit in Chennai with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is Chennai’s most iconic landmark, stretching for over 13 km along the Bay of Bengal. It is one of the longest urban beaches in the world. Visitors enjoy sunrise walks, horse rides, and street food stalls serving local favorites. Memorials of leaders like MGR and Anna add historical value. Evenings are vibrant with families and tourists. Marina Beach is Chennai’s lively coastal heart."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a 7th-century shrine dedicated to Lord Shiva. Its colorful Dravidian-style gopuram is adorned with intricate carvings. The temple is a hub of spirituality, music, and culture. Festivals like Panguni Peruvizha are celebrated with grandeur. Devotees and tourists admire its spiritual aura and architectural beauty. Kapaleeshwarar is Chennai’s divine heritage gem."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, built in 1644 by the British East India Company, is the first English fortress in India. Today it houses the Tamil Nadu Legislative Assembly and Secretariat. The fort museum displays colonial-era artifacts, coins, and uniforms. St. Mary’s Church inside is India’s oldest Anglican church. Its colonial charm narrates the city’s history. Fort St. George is Chennai’s historic landmark of power."
  },
  {
    "title": "Santhome Cathedral Basilica",
    "description": "Santhome Basilica, built over the tomb of St. Thomas the Apostle, is one of only three basilicas in the world constructed over an apostle’s remains. The neo-gothic architecture, stained glass windows, and tall spires are stunning. Pilgrims and tourists visit for blessings and history. The underground chapel houses the saint’s relics. It is both spiritual and historic. Santhome Basilica is Chennai’s sacred Christian landmark."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a grand monument dedicated to the Tamil poet-saint Thiruvalluvar. Built in the shape of a temple chariot, it houses a life-size statue of the saint. The auditorium inside is one of Asia’s largest. The monument displays 1330 verses of Thirukkural inscribed on its walls. Visitors admire its cultural and architectural value. Valluvar Kottam is Chennai’s ode to Tamil literature."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of the few wildlife reserves located inside a major city. It is home to blackbucks, spotted deer, jackals, and numerous bird species. Families also enjoy the adjoining children’s park and snake park. The greenery offers a refreshing escape from city life. Nature lovers and students find it educational. Guindy is Chennai’s natural wilderness retreat."
  },
  {
    "title": "Elliot’s Beach (Besant Nagar Beach)",
    "description": "Elliot’s Beach, also known as Besant Nagar Beach, is a quieter alternative to Marina. It is popular among youngsters and families for evening outings. The beach is lined with cafes, eateries, and the iconic Karl Schmidt Memorial. Its clean sands and relaxed vibe attract tourists. Sunrises here are especially scenic. Elliot’s Beach is Chennai’s modern coastal getaway."
  },
  {
    "title": "Government Museum, Egmore",
    "description": "The Government Museum in Egmore, established in 1851, is the second oldest museum in India. It houses archaeological artifacts, bronzes, Amravati sculptures, and a children’s museum. The National Art Gallery inside is a treasure of paintings and handicrafts. Students, historians, and tourists find it highly educational. Its Indo-Saracenic architecture adds charm. Egmore Museum is Chennai’s cultural treasure house."
  },
  {
    "title": "Parthasarathy Temple",
    "description": "Parthasarathy Temple in Triplicane is a 6th-century Vaishnavite temple dedicated to Lord Krishna as Parthasarathy. Its gopurams and inscriptions narrate Pallava and Chola history. The temple is always bustling with devotees and rituals. Annual Brahmotsavam is celebrated with grandeur. Its rich heritage attracts pilgrims and culture lovers alike. Parthasarathy Temple is Chennai’s ancient spiritual gem."
  },
  {
    "title": "Arignar Anna Zoological Park (Vandalur Zoo)",
    "description": "Located on the outskirts of Chennai, Arignar Anna Zoological Park is India’s first public zoo and one of the largest in South Asia. Spread over 1,300 acres, it houses tigers, lions, elephants, reptiles, and over 170 species. Safari rides and aviaries attract families and tourists. It is also a hub for conservation and research. Vandalur Zoo is Chennai’s grand wildlife attraction."
  }
],


                   "services": [
    {
      "name": "Pune to Chennai Cab",
      "description": "Enjoy comfortable and reliable travel with our Pune to Chennai Cab service, featuring well-maintained vehicles and experienced drivers for your long-distance journey."
    },
    {
      "name": "Book Pune to Chennai Taxi Online",
      "description": "Easily book your Pune to Chennai Taxi online with instant confirmation, flexible pickup options, and secure payment gateways for hassle-free planning."
    },
    {
      "name": "Pune to Chennai Car Rental",
      "description": "Choose from a wide selection of cars for Pune to Chennai Car Rental, including self-drive and chauffeur-driven options tailored to your travel preferences."
    },
    {
      "name": "Pune to Chennai One Way Cab",
      "description": "Opt for our Pune to Chennai One Way Cab service for cost-effective, single-direction travel ideal for relocations, business trips, and leisure travel."
    },
    {
      "name": "Cab from Pune to Chennai",
      "description": "Reliable Cab from Pune to Chennai service offering safe, timely transportation with professional drivers and comfortable vehicles."
    },
    {
      "name": "Pune to Chennai Outstation Cab Booking",
      "description": "Book your Pune to Chennai Outstation Cab with ease, ensuring a smooth journey with transparent pricing and flexible scheduling."
    },
    {
      "name": "Pune to Chennai Taxi Fare",
      "description": "Get clear and upfront Pune to Chennai Taxi Fare details to plan your travel budget effectively without any hidden charges."
    },
    {
      "name": "Affordable Pune to Chennai Cab Service",
      "description": "Travel smart with our Affordable Pune to Chennai Cab Service, providing budget-friendly options without compromising on quality or comfort."
    },
    {
      "name": "Chennai to Pune Taxi Service",
      "description": "Dependable Chennai to Pune Taxi Service for your return journey, featuring prompt pickups, clean vehicles, and professional drivers."
    },
    {
      "name": "Pune to Chennai Cab Charges",
      "description": "Transparent Pune to Chennai Cab Charges with no hidden fees, helping you manage your travel expenses with confidence."
    },
    {
      "name": "Pune to Chennai Road Trip Taxi",
      "description": "Enjoy a scenic and comfortable Pune to Chennai Road Trip Taxi experience with our experienced drivers and well-equipped vehicles."
    }
  ],
  "tableData": [
    ["Pune to Chennai Cab", "Book Pune to Chennai Taxi Online"],
    ["Pune to Chennai Car Rental", "Pune to Chennai One Way Cab"],
    ["Cab from Pune to Chennai", "Pune to Chennai Outstation Cab Booking"],
    ["Pune to Chennai Taxi Fare", "Affordable Pune to Chennai Cab Service"],
    ["Chennai to Pune Taxi Service", "Pune to Chennai Cab Charges"],
    ["Pune to Chennai Road Trip Taxi", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Chennai Cab Booking",
    "WhyChoosedescription": "Platinum24 Cabs offers trustworthy and comfortable cab booking services for your journey from Pune to Chennai, ensuring a smooth travel experience."
  },
  {
    "WhyChooseheading": "Wide Selection of Vehicles to Suit Your Needs",
    "WhyChoosedescription": "Choose from sedans, SUVs, hatchbacks, and tempo travellers perfect for your Pune to Chennai trip."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Vehicles for Safe Travel",
    "WhyChoosedescription": "All cabs are regularly cleaned and sanitized to ensure a safe and hygienic ride from Pune to Chennai."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Chennai Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Chennai to ensure timely and comfortable travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy affordable fares with all costs including fuel, tolls, and driver allowances clearly included."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round the clock to assist with your Pune to Chennai cab bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans that suit your Pune to Chennai travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Chennai cab quickly and securely via our website or app with immediate confirmation."
  }
]























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Chennai cab booking services?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel from Pune to Chennai.',
    },
    {
        question: 'How can I book a cab from Pune to Chennai?',
        answer: 'You can book your cab easily via our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Chennai travel?',
        answer: 'We provide hatchbacks, sedans, SUVs, and luxury cars to suit your travel needs and preferences.',
    },
    {
        question: 'Is one-way cab booking available from Pune to Chennai?',
        answer: 'Yes, both one-way and round-trip cab bookings are available for Pune to Chennai routes.',
    },
    {
        question: 'Are the drivers experienced for Pune to Chennai long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, experienced, and familiar with the Pune to Chennai route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Chennai?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Pune and Chennai.',
    },
    {
        question: 'What safety and hygiene measures are followed for Pune to Chennai cabs?',
        answer: 'All vehicles are sanitized regularly, and drivers follow strict safety protocols to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Chennai cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Chennai cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Chennai cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for easy payment.',
    },
    {
        question: 'Are customizable packages available for Pune to Chennai cab service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Suresh Iyer',
        feedback: 'The Pune to Chennai cab booking service was seamless, with a comfortable ride and punctual driver.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Lakshmi Rao',
        feedback: 'Highly satisfied with the professionalism and service quality on my Pune to Chennai trip.',
        rating: 5,
    },
];













































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToChennaiCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Chennai Cab Booking",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-chennai-cab.jpg",
  "description": "Book Pune to Chennai cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-chennai-cab-booking"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Chennai Cab Booking | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Chennai cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Chennai Cab, Book Pune to Chennai Taxi Online, Pune to Chennai Car Rental, Pune to Chennai One Way Cab, Cab from Pune to Chennai, Pune to Chennai Outstation Cab Booking, Pune to Chennai Taxi Fare, Affordable Pune to Chennai Cab Service, Chennai to Pune Taxi Service, Pune to Chennai Cab Charges, Pune to Chennai Road Trip Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToChennaiCabSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/107.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetochennaicabbooking;